import API from 'util/API';
import { loadMenu, saveMenu } from "util/menuUtils";


export const getMenu = async (restaurantId, tableId, shortUrlCode, processMenuData) => {
  // console.log("getMenu", restaurantId, tableId);

  if(!restaurantId || restaurantId === "null" || restaurantId === "undefined" || !tableId || tableId === "null" || tableId === "undefined") {
    throw new Error("Invalid restaurantId or tableId");
  }

  const menu = loadMenu(restaurantId, tableId);

  if(menu && menu.version && menu.menuId) {
    API.defaults.headers.common["menuVersion"] = menu.version;
    API.defaults.headers.common["menuId"] = menu.menuId;
  }

  const response = await API.get("/online?menuId=" + restaurantId + "&tableId=" + tableId + "&shortUrlCode=" + (shortUrlCode || ""));
  if (response && response.data) {
    if (response.data.isSameVersion === true && menu) {
       processMenuData && processMenuData({...response.data, menu});
    } else if (response.data.menu) {
      saveMenu(tableId, restaurantId, response.data.menu);
    }
    processMenuData && processMenuData({...response.data});
  }
  return null;
};

export const generateMenuCode = async (restaurantId, menuId, tableNumber, orderType, isPaymentRequired, isAllowOrder) => {
  const response = await API.post("/generateMenuCode", {restaurantId, menuId, tableNumber, orderType, isPaymentRequired, isAllowOrder});
  return response.data;
};

// Resolves a draft menu exactly the way publishing would, stores it behind a
// short code and returns the link. Nothing goes live until you publish.
export const createMenuPreview = async (menuId) => {
  const response = await API.post(`/menuPreview/${menuId}`);
  return response.data;
};

// Public: no auth needed, the point of the link is handing it to someone else.
export const getMenuPreview = async (code) => {
  const response = await API.get(`/menuPreview/${code}`);
  return response.data;
};

export const getAllMenus = async (restaurantId) => {
  const response = await API.get("/myMenus");
  
  return response.data && response.data.menus ? response.data.menus : [];
};

// Fetch active promotions for a restaurant (for online menu)
export const getActivePromotions = async (restaurantId, tableId) => {
  const response = await API.get(`/obPromotions?restaurantId=${restaurantId}&tableId=${tableId}`);
  if (response && response.data && response.data.promotionDetails) {
    // console.log("getActivePromotions", response.data.promotionDetails);
    return response.data.promotionDetails;
  }
  return null;
};

export const getLiveTransactions = async () => {
  const response = await API.get('/liveTransactions');
  if (response && response.data) {
    return response.data;
  }
  return [];
};

export const deleteTransaction = async (transactionId) => {
  const response = await API.delete(`/liveTransactions/${transactionId}`);
  return response.data;
};

export const deleteAllOldTransactions = async () => {
  const response = await API.post('/deleteAllOldTransactions');
  return response.data;
};